import { Component, OnInit } from "@angular/core";
import { DialogService } from "src/app/services/dialog.service";
import { SnackbarService } from "src/app/services/snackbar.service";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { CopyAcessPopupComponent } from "./copy-acess-popup/copy-acess-popup.component";

export interface AcessUser {
  id: any;
  name: string;
}

@Component({
    selector: "app-acess-view",
    templateUrl: "./acess-view.component.html",
    styleUrls: ["./acess-view.component.scss"],
    standalone: false
})
export class AcessViewComponent implements OnInit {

  usersData: AcessUser[] = [];
  userInputFilter: string = "";
  selectedUser: AcessUser = null;
  loadingUsers: boolean = false;
  menusOpen: boolean = true;
  companiesOpen: boolean = true;
  instancesOpen: boolean = true;
  private filterTimer: any;

  constructor(
    private uas: UserAuthenticationServices,
    private dialogServices: DialogService,
    private snackBar: SnackbarService
  ) {}

  ngOnInit(): void {
    this.loadUsers(null);
  }

  loadUsers(filter: any) {
    if (filter == null || filter.length == 0) {
      filter = null;
    }

    this.loadingUsers = true;
    this.uas.getAllUsers(filter).then((x) => {
      this.usersData = this.uas.usersArr;
      this.loadingUsers = false;
    });
  }

  updateFilterUser() {
    clearTimeout(this.filterTimer);
    this.filterTimer = setTimeout(() => this.loadUsers(this.userInputFilter), 300);
  }

  clearFilterUser() {
    this.userInputFilter = "";
    this.loadUsers(null);
  }

  selectUser(user: AcessUser) {
    this.selectedUser = user;
  }

  syncAcess() {
    this.uas.syncAcessToAllCompaniesUser(this.selectedUser.id).then((x) => {
      this.snackBar.showInformation("Acessos sincronizados com sucesso.");
    });
  }

  openCopyAcessPopUp() {
    this.dialogServices.openGenericDialog(CopyAcessPopupComponent, this.selectedUser, (popUpData) => {
      if (popUpData != null && popUpData.length > 0) {

        let popUpDataArr = Array.prototype.slice.call(popUpData);

        let usersDest = null;

        popUpDataArr.forEach((usuarioDest) => {
          if (usersDest == null) {
            usersDest = usuarioDest.id;
          } else {
            usersDest += "," + usuarioDest.id;
          }
        });

        this.copyAcessFromUser(this.selectedUser.id, usersDest);
      }
    }, () => {
      this.snackBar.showInformation("Processo abortado pelo usuário.");
    }, "100%");
  }

  copyAcessFromUser(codUsu, usersDest) {
    this.uas.copyAcessFromUser(codUsu, usersDest).then((x) => {
      this.snackBar.showInformation("Acessos copiados com sucesso.");
    });
  }
}
